import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const harpoonDialog = [
  new Dialog(
    "HARBOUR MASTER: Poseidon’s Wrath be upon any lost soul who wanders aboard this doomed vessel!",
    require("@/images/Harbourmaster.png"),
    require("@/audio/Pandemic-90-Harbourmaster-MP3.mp3")
  ),
  new Dialog(
    "[The HARBOUR MASTER impales you with a harpoon!]",
    require("@/images/Harpoon.png"),
    require("@/audio/loseitem.mp3")
  ),
];

const doctorYangDialog = [
  new Dialog(
    "[Equipped SURGICAL MASK]",
    require("@/images/Masked_Sonny_Yang.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    '"DOCTOR" SONNY YANG: I say Harbour Master, might I be able to board this here ship?',
    require("@/images/Masked_Sonny_Yang.png"),
    require("@/audio/Pandemic-91-Sonny-MP3.mp3")
  ),
  new Dialog(
    "HARBOUR MASTER: Aye Doctor, aye.The Queen Maude awaits ye…",
    require("@/images/Harbourmaster.png"),
    require("@/audio/Pandemic-91-Harbourmaster-MP3.mp3")
  ),
];

const cleaningDialog = [new Dialog(
  "HARBOUR MASTER: Arrggh, I’m afraid the Queen Maude is undergoing an extensive deep cleaning procedure.",
  require("@/images/Harbourmaster.png"),
  require("@/audio/Pandemic-97-Harbourmaster-MP3.mp3")
)
]
export class CruiseShipExterior extends Scene {
  async init() {
    this.description = "";
    this.audio = null;
    this.image = require("@/images/Cruise_Ship_Exterior.png");
    this.title = "Quarantined Cruise Ship";
  }

  get options(): any[] {
    return [
      new Choice("Board Ship", async () => {
        if (this.state.inventory.tongs.has) {
          await this.dialogRunner(cleaningDialog)
          await this.init()

        } else if (this.state.inventory.facemask.has) {
          await this.dialogRunner(doctorYangDialog)
          await this.navigate(scenes.CruiseShipInterior())
        } else {
          await this.dialogRunner(harpoonDialog)
          await this.navigate(scenes.EmergencyRoom())
        }
      }),
      new Choice("Read sign", () => {
        this.image = require("@/images/Cruise_Ship_Exterior.png");
        this.description =
          "SONNY YANG : The sign reads: “The Queen Maude has been docked under indefinite quarantine while the passengers and crew are being tested for YOGID - 19. For your own safety, please refrain from boarding the ship.";
        this.audio = require("@/audio/Pandemic-89-Sonny-MP3.mp3");
      }),
      new Choice("Leave", async () => await this.navigate(scenes.Harbour())),
    ];
  }
}

export default new CruiseShipExterior();
